export const stripHtml = (html: string | undefined | null): string => {
    if (!html) return "";
    return html
        .replace(/<br\s*\/?\s*>/gi, " ")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;|&#160;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;|&#8217;|&#x2019;/g, "'")
        .replace(/\s+/g, " ")
        .trim();
};

const DEFAULT_MAX = 125;

export const truncateAlt = (text: string, max: number = DEFAULT_MAX): string => {
    if (text.length <= max) return text;
    const head = text.slice(0, max);
    const lastSpace = head.lastIndexOf(" ");
    const cut = lastSpace > Math.floor(max * 0.4) ? head.slice(0, lastSpace) : head;
    return cut.trimEnd() + "…";
};

export const altFromHtml = (html: string | undefined | null, max: number = DEFAULT_MAX): string =>
    truncateAlt(stripHtml(html), max);
